import { render, staticRenderFns } from "./Submenu.vue?vue&type=template&id=7f311776&scoped=true&"
import script from "./Submenu.vue?vue&type=script&lang=js&"
export * from "./Submenu.vue?vue&type=script&lang=js&"
import style0 from "./Submenu.vue?vue&type=style&index=0&id=7f311776&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f311776",
  null
  
)

export default component.exports